import { render, staticRenderFns } from "./AddInputsToStartNodeModal.vue?vue&type=template&id=bc8a8f64"
import script from "./AddInputsToStartNodeModal.vue?vue&type=script&lang=js"
export * from "./AddInputsToStartNodeModal.vue?vue&type=script&lang=js"
import style0 from "./AddInputsToStartNodeModal.vue?vue&type=style&index=0&id=bc8a8f64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports